// extracted by mini-css-extract-plugin
module.exports = {"documentTitle":"styles_documentTitle__32KcF","title":"styles_title__3VjiL"};